<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">

          <!-- Page Header -->
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title">My Performance Reviews</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Performance Reviews</li>
                </ul>
              </div>
              
            </div>
          </div>
          <!-- /Page Header -->
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="alert alert-success" role="alert" v-if="period.departmentId === null || period.departmentId === currentUser.employee.designation.departmentId">
                                    <h4 class="alert-heading">Performance Time!</h4>
                                    <p>It’s time for you to complete your self-assessment. This is an opportunity for you to reflect on your achievements, challenges, and overall contributions over the review period.</p>
                                    <hr>
                                    <p class="mb-0">Kindly complete your self-review by {{ period.endDate ? new Date(period.endDate).toLocaleDateString() : '' }}.  <a @click="startReview">Start Now</a></p>
                                  </div>
                                   <div class="card">
                                    <div class="card-header">
                                      <div class="d-flex justify-content-between">
                                        <h4 class="card-title mb-0">Perfomance Reviews</h4>
                                        <div class="col-auto float-right ml-auto">
                                            <a class="btn add-btn ml-1" @click="startReview" v-if="(period.departmentId === null || period.departmentId === currentUser.employee.designation.departmentId) && !loading"><i
                                        class="fa fa-plus"></i> Start Review</a>
                                        </div>
                                        
                                      </div>
                                    </div>
                              <div class="card-body">
                              <!----Datatable-->
                                <div class="row">
                                    <div class="col-md-12">
                                    <div class="table-responsive">
                                    
                                  <v-data-table
                                    :headers="headers"
                                    :items="reviews"
                                    sort-by=""
                                    class="elevation-1"
                                  >
                                    <template v-slot:[`item.profile`]="{ item }">
                                      <h2 class="table-avatar blue-link">
                                        <router-link :to="{name: 'employeeReviewDetailHR', params: {id: item.id}}" class="avatar"><img alt=""
                                                            src="~@/assets/profiles/avatar-02.jpg" v-if="!item.employee.passportPhoto">
                                                            <img alt="" :src="media + item.employee.passportPhoto" width="38" v-if="item.employee.passportPhoto"
                                        /></router-link>
                                        <router-link :to="{name: 'employeeReviewDetailHR', params: {id: item.id}}">{{
                                            `${item.employee.firstName} ${item.employee.lastName}`
                                            }}</router-link>
                                        </h2>
                                    </template>
                                    <template v-slot:[`item.averageSelfResult`]="{ item }">
                                      {{  `${item.averageSelfResult}%` }}
                                    </template>
                                    <template v-slot:[`item.averageManagerResult`]="{ item }">
                                      {{  `${item.averageManagerResult}%` }}
                                    </template>
                                    <template v-slot:[`item.selfSigned`]="{ item }">
                                      {{ item.employeeSignDate != '0001-01-01T00:00:00' ? new Date(item.employeeSignDate).toLocaleDateString() : 'Not yet' }}
                                    </template>
                                    <template v-slot:[`item.managerSigned`]="{ item }">
                                      {{ item.managerSignDate != '0001-01-01T00:00:00' ? new Date(item.managerSignDate).toLocaleDateString() : 'Not yet' }}
                                    </template>
                                    <template v-slot:[`item.stat`]="{ item }">
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 0"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-purple"></i> New
                                      </a>
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 1"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-primary"></i> Awaiting Submission
                                      </a>
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 2"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-primary"></i> Awaiting Manager Review
                                      </a>
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 3"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-primary"></i> Awaiting Employee Acceptance
                                      </a>
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 4"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-primary"></i> Employee Accepted Rating
                                      </a>
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 5"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-sucess"></i> Employee Declined Rating
                                      </a>
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 6"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-primary"></i> Awaiting Other Manager Review
                                      </a>
                                      <!-- what comes after?? -->
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 7"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-primary"></i> Completed
                                      </a>
                                    </template>
                                    <template v-slot:[`item.actions`]="{ item }">
                                
                                        <div class="dropdown dropdown-action">
                                        <a
                                            href="#"
                                            class="action-icon dropdown-toggle"
                                            data-toggle="dropdown"
                                            aria-expanded="false"
                                            ><i class="material-icons">more_vert</i></a
                                        >
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <router-link :to="{name: 'employeeReviewDetailHR', params: {id: item.id}}"
                                            class="dropdown-item"
                                            
                                            ><i class="fa fa-pencil m-r-5"></i> Details</router-link
                                            >
                                            
                                        </div>
                                        </div>
                                    </template>
                                    </v-data-table>
                                    </div>
                                    </div>
                                </div>
                                <!---/Datatable-->
                              </div>
                              </div>
                                </div>
                               
                              </div>
                              
                                
                           
          <!-- /Page Content -->
        </div>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/sidebar.vue";
import { authenticationService } from '@/services/authenticationService';
import { performanceService } from '@/services/performanceService';
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
      return {
        dialogDelete: false,
        headers: [
          {
            text: 'Employee',
            align: 'start',
            value: 'profile',
          },
          { text: 'Period', value: 'reviewPeriod.name' },
          {text: 'Self Rating', value: 'averageSelfResult' },
          { text: 'Manager Rating', value: 'averageManagerResult' },
          { text: 'Self Reviewed', value: 'selfSigned' },
          { text: 'Manager Reviewed', value: 'managerSigned' },
          { text: 'Status', value: 'stat' },
          { text: '', value: 'actions', sortable: false },
        ],
        employeeId: authenticationService.currentUserValue.employee.id,
        company: authenticationService.currentOfficeValue,
        currentUser: authenticationService.currentUserValue,
        period: null,
        reviews: [],
        review: null,
        submitted: false,
        loading: false,
        error: ""
    }
   },
  mounted() {
      this.getActiveReview()
      this.getReview()
        if ($('.datatable').length > 0) {
            $('.datatable').DataTable({
            "bFilter": false,
            });
        }
  },

  methods: {
    getReview () {
      performanceService.getReviewByEmployee(this.currentUser.employee.id)
          .then(
            model => { 
            this.reviews = model
            console.log(model) },
            error => { error = error }
          )
    },
    getActiveReview () {
      performanceService.getActiveReviewPeriodByEmployee(this.currentUser.employee.id)
          .then(
            model => { 
              this.period = model
              console.log(model) 
            },
            error => { error = error }
          )
    },
    startReview() {
      this.loading = true
        var review = {
          employeeId: this.currentUser.employee.id,
          designationId: this.currentUser.employee.designationId,
          reviewPeriodId: this.period.id
        }

         performanceService.addReview(review).then(
            m => {
                this.$router.push('/employee-review-detail/'+m)
            },
            error => {
                this.error = error;
                this.loading = false;
            }
        )
    }
  },
  name: "addGoalActivity"
};
</script>
<style scoped>
.datelay {
    z-index: 100;
}

.datatable > thead > tr > th,
.datatable > tbody > tr > td {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/review/myReviewsHR.vue